var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import { motion } from 'framer-motion';
import { Fragment } from 'react';
export function ScoreGraph(_a) {
    var score = _a.score, _b = _a.color, color = _b === void 0 ? 'linear-gradient(0deg, rgba(195,44,16,1) 0%, rgba(226,110,7,1) 50%, rgba(153,188,37,1) 100%)' : _b, labelProps = _a.labelProps, needleProps = _a.needleProps, markerProps = _a.markerProps, className = _a.className, _c = _a.markers, markers = _c === void 0 ? [
        {
            value: 85,
            text: 'Your Hearing is OK',
        },
        {
            value: 72.5,
            marker: true,
        },
        {
            value: 50,
            text: 'Some Difficulty Hearing',
        },
        {
            value: 27.5,
            marker: true,
        },
        {
            value: 15,
            text: 'Significant Hearing Difficulties',
        },
    ] : _c, _d = _a.transform, transform = _d === void 0 ? function (value) { return value; } : _d;
    return (_jsxs(Wrapper, __assign({ "aria-hidden": true }, { children: [_jsx(Graph, { color: color, className: className }), _jsx(Needle, __assign({ score: transform(score) }, needleProps)), markers.map(function (_a, index) {
                var value = _a.value, text = _a.text, marker = _a.marker;
                return (_jsxs(Fragment, { children: [text && (_jsx(Label, __assign({}, labelProps, { value: transform(value), text: text }))), marker && _jsx(Marker, __assign({}, markerProps, { value: transform(value) }))] }, "score-graph-marker".concat(index)));
            })] })));
}
export default ScoreGraph;
var Wrapper = styled('div')({
    position: 'relative',
    width: '6rem',
    height: '18rem',
});
var Graph = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'color'; },
})(function (_a) {
    var color = _a.color, className = _a.className;
    return ({
        position: 'absolute',
        left: '22.5%',
        top: 0,
        bottom: 0,
        right: '22.5%',
        zIndex: -1,
        background: color,
        className: className,
    });
});
var Marker = styled('div', {
    shouldForwardProp: function (prop) {
        return prop !== 'value' && prop !== 'styles' && prop !== 'color';
    },
})(function (_a) {
    var value = _a.value, _b = _a.color, color = _b === void 0 ? 'black' : _b, _c = _a.styles, styles = _c === void 0 ? {} : _c;
    return (__assign({ position: 'absolute', bottom: "".concat(value, "%"), left: 0, right: 0, borderBottom: "3px dashed ".concat(color), height: 0 }, styles));
});
var Needle = function (_a) {
    var score = _a.score, adornment = _a.adornment, labelStyles = _a.labelStyles, _b = _a.dontShowCircle, dontShowCircle = _b === void 0 ? false : _b;
    return (_jsxs(MotionNeedleWrapper, __assign({ initial: { top: 'calc(100% - 0.5rem)' }, animate: { top: "calc(".concat(100 - score, "% - 0.5rem)") }, transition: { ease: 'easeOut', duration: 1.5 } }, { children: [!dontShowCircle && _jsx(Circle, {}), _jsx(NeedleLabel, __assign({ styles: labelStyles }, { children: "YOUR HEARING" })), adornment && _jsx(NeedleAdornment, { children: adornment })] })));
};
var NeedleAdornment = styled('div')({
    position: 'absolute',
    left: '9rem',
});
var NeedleWrapper = styled('div')({
    position: 'absolute',
    left: 'calc(50% - .5rem)',
    zIndex: 1,
});
var MotionNeedleWrapper = motion(NeedleWrapper);
var Circle = styled('div')({
    backgroundColor: 'white',
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
    position: 'absolute',
});
var NeedleLabel = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'styles'; },
})(function (_a) {
    var theme = _a.theme, styles = _a.styles;
    return (__assign({ backgroundColor: theme.palette.common.black, borderRadius: '999px', left: '0.5rem', top: '-0.2rem', position: 'absolute', zIndex: '-1', color: theme.palette.common.white, width: '8.6rem', fontSize: '0.8125rem', fontWeight: 'bold', paddingLeft: '1rem', height: '1.5rem', display: 'flex', placeItems: 'center', whiteSpace: 'nowrap' }, styles));
});
var Label = function (_a) {
    var value = _a.value, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.position, position = _d === void 0 ? 'left' : _d, props = __rest(_a, ["value", "text", "className", "position"]);
    return (_jsx(LabelWrapper, __assign({ sx: {
            top: "calc(".concat(100 - value, "% - 1rem)"),
            position: position,
            textAlign: position === 'right' ? 'left' : 'right',
        }, className: className }, props, { children: text })));
};
var LabelWrapper = styled('div')(function (_a) {
    var _b;
    var styles = _a.styles, theme = _a.theme, sx = _a.sx;
    return (__assign((_b = { position: 'absolute', '--width': '5rem', '--offset': '0.5rem', left: (sx === null || sx === void 0 ? void 0 : sx.position) === 'right'
                ? 'calc(100% + var(--offset))'
                : 'calc(var(--width) * -1 - var(--offset))', width: 'var(--width)', fontSize: '0.875rem', textAlign: 'right' }, _b[theme.breakpoints.up('sm')] = {
        '--width': '10rem',
    }, _b), styles));
});
